/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CN from 'classnames';
import { Button, Input, SimpleSelect } from 'components/atoms';
import {
  useAddEnterprise,
  // useSaveVideo,
} from 'framework/api/methods';
import { format } from 'path';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import isEmail from 'utils/isEmail';
import isPhoneNumber from 'utils/isPhoneNumber';

export interface EnterpriseCreateProps {
  [x: string]: any;
}

export const EnterpriseCreate: FC<EnterpriseCreateProps> = () => {
  const navigate = useNavigate();
  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [formData, setFormaData] = useState({
    name: '',
    address: '',
    email: '',
    brn: '',
    phone: '',
    password: '',
    package: {
      value: '',
      label: '',
    },
  });

  const clearValues = () => {
    setFormaData({
      name: '',
      address: '',
      email: '',
      brn: '',
      phone: '',
      password: '',
      package: {
        value: '',
        label: '',
      },
    });
  };

  const { mutate: addEnterpriseMutate, isLoading: addEnterpriseIsLoading } = useAddEnterprise();

  const addEnterprise = () => {
    addEnterpriseMutate(
      {
        enterpriseName: formData.name,
        email: formData.email,
        address: formData.address,
        password: formData.password,
        BRNumber: formData.brn,
        phone: formData.phone,
        packages: formData.package.value,
      },
      {
        onSuccess: async ({ data }: any) => {
          clearValues();
          notify('New enterprise added successfully!', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-full p-8 overflow-y-auto">
      <div className="bg-[white] shadow-md px-10 py-4 flex flex-col w-1/2 h-fit rounded">
        <div className="flex w-full justify-center items-center h-fit text-[#C40D42]">
          Enterprise information
        </div>

        <div className="flex w-full h-full gap-x-5 mt-6">
          <div className="w-1/2 flex flex-col">
            <Input
              labelValue="Enterprises Name"
              inputClassName="!rounded"
              appearance="gray"
              value={formData.name}
              isRequired
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  name: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Business Register Number"
              inputClassName="!rounded"
              className="mt-2"
              appearance="gray"
              value={formData.brn}
              isRequired
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  brn: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Phone"
              inputClassName="!rounded"
              appearance="gray"
              className="mt-2"
              value={formData.phone}
              placeholder="0XXXXXXXXX"
              isRequired
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, ''); // remove all non-digits
                setFormaData({
                  ...formData,
                  phone: numericValue,
                });
              }}
            />

            <div className="flex flex-col mt-5">
              <span className="text-[#737791] pb-1 text-sm">Packages</span>

              <div className="w-full">
                <SimpleSelect
                  isWhiteBg={false}
                  isDefault={false}
                  isShortMenu
                  isFormAppearance
                  options={[
                    { label: 'Package 1', value: 'Package 1' },
                    { label: 'Package 2', value: 'Package 2' },
                    { label: 'Package 3', value: 'Package 3' },
                    { label: 'Dialog', value: 'Dialog' },
                  ]}
                  value={formData.package?.value === '' ? null : formData.package}
                  onChange={(e) => {
                    setFormaData({
                      ...formData,
                      package: e,
                    });
                  }}
                />
              </div>
            </div>
          </div>

          <div className="w-1/2 flex flex-col gap-y-2">
            <Input
              labelValue="Address"
              inputClassName="!rounded"
              appearance="gray"
              isRequired
              value={formData.address}
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  address: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Email"
              inputClassName="!rounded"
              appearance="gray"
              isRequired
              value={formData.email}
              onChange={(e) => {
                setFormaData({
                  ...formData,
                  email: e.target.value,
                });
              }}
            />

            <div className="flex gap-x-2 relative">
              <Input
                labelValue="Password"
                inputClassName="!rounded"
                appearance="gray"
                value={formData.password}
                isRequired
                onChange={(e) => {
                  setFormaData({
                    ...formData,
                    password: e.target.value,
                  });
                }}
              />

              <i
                className={CN(
                  'ri-file-copy-2-line absolute bottom-2 -right-[30px] text-[24px] text-[#63717A] cursor-pointer',
                  {
                    hidden: formData.password === '',
                  },
                )}
                onClick={() => {
                  if (formData.password) {
                    navigator.clipboard.writeText(formData.password);
                    notify('Password copy to clipboard.', 'success');
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end w-full">
          <Button
            isRounded
            className="mt-2"
            isLoading={addEnterpriseIsLoading}
            disabled={
              !formData.name ||
              !formData.brn ||
              !formData.address ||
              !formData.email ||
              !formData.password ||
              !formData.phone ||
              !formData.package?.value
            }
            onClick={() => {
              if (!isEmail(formData.email)) {
                notify('Invalid email address', 'error');
                return;
              }

              if (!isPhoneNumber(formData.phone)) {
                notify('Invalid phone number. Must be 10 digits.', 'error');
                return;
              }

              addEnterprise();
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseCreate;
